<template>
    <div class="form-group row"
         v-bind:class="{ 'has-danger': error }">
        <div class="form-control-input col-12">
            <textarea class="input-block-level" :ref="`summernote_${forType}_${index}`" :id="`summernote_${forType}_${index}`" :placeholder="placeholder" name="content" rows="14">
            {{ content }}
            </textarea>
            <div class="editor-clear"></div>
            <small class="invalid-feedback d-block"
                   v-show="error">
                {{ error }}
            </small>
        </div>
        <div v-show="helpText"
             class="col-2 col-md-1 align-self-center">
            <a tabindex="-1"
               class="btn btn-xs btn-round btn-outline-info w-20 h-20"
               data-toggle="popover"
               data-trigger="focus"
               data-html="true"
               :title="helpTitle"
               :data-content="helpText">
                <i class="fa fa-question"></i>
            </a>
        </div>
    </div>


</template>
<script>
export default {
    props: {
        index: {
            type: String,
            required: true,
        },
        content: {
            type: String,
            required: false,
        },
        placeholder: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: false,
        },
        onChange: {
            type: Function,
            required: false,
        },
        onChangeContent: {
            type: Function,
            required: false,
        },
        forType: {
            type: String,
            required: true,
        },
        error: {
            type: String,
            required: false,
        },
        helpTitle: {
            type: String,
            required: false,
        },
        helpText: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            note: '',
        }
    },

    mounted(){

        $.ajax({
            url: 'https://api.github.com/emojis',
            async: false
        }).then(function(data) {
            window.emojis = Object.keys(data);
            window.emojiUrls = data;
        });

        const that = this;
        const config = {};
        config.minHeight = null;
        config.focus = true;
        config.popover = {
            air: []
        };
        config.hint = {
            match: /:([\-+\w]+)$/,
            search: function (keyword, callback) {
                callback($.grep(emojis, function (item) {
                    return item.indexOf(keyword)  === 0;
                }));
            },
            template: function (item) {
                var content = emojiUrls[item];
                return '<img src="' + content + '" width="20" /> :' + item + ':';
            },
            content: function (item) {
                var url = emojiUrls[item];
                if (url) {
                    return $('<img />').attr('src', url).css('width', 20)[0];
                }
                return '';
            }
        }
        config.tabsize = 2
        config.toolbar =  [
            ['style', ['bold']],
            ['font', ['superscript', 'subscript']],
            ['fontsize', ['fontsize']],
            ['color', ['color']],
            ['para', ['ul', 'ol']],
            ['table', ['table']],
            ['insert', ['picture']],

        ];
        config.inheritPlaceholder = true;
        config.callbacks = {
            // callback for pasting text only (no formatting)
            // https://stackoverflow.com/questions/30993836/paste-content-as-plain-text-in-summernote-editor#answer-49632024
            onPaste: function (e) {
                var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                e.preventDefault();
                bufferText = bufferText.replace(/\r?\n/g, '<br>');
                document.execCommand('insertHtml', false, bufferText);
            }
        }

        const summerNoteId =  `#summernote_${that.forType}_${that.index}`;

        $(summerNoteId).on("summernote.change", function (we, contents, $editable) {   // callback as jquery custom event
            var regX = /(<([^>]+)>)/ig;
            let titleText = contents.replace(regX, "").replace(/&nbsp;/g, " ");
            if (that.onChange) {
                that.onChange (titleText);
            }
            if (that.onChangeContent) {
                that.onChangeContent(contents);
            }
        });

        if ($.fn.summernote) {
            const _this = this;
            this.ContentHTML = $(this.$refs['summernote_' + _this.forType + '_' + _this.index]);
            _this.ContentHTML.summernote(config);
        } else {
            alert('The text editor is not loaded properly for the content.');
        }
    },
}
</script>
<style scoped>
.note-toolbar {
    position: absolute;
    bottom: -40px;  /*at will*/
    border-bottom: none;  /*at will*/
    /* ... something else here ... */
}
</style>